import { OptionType } from '@evinced-private/ui-common';

import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';

export const TEXT_INPUT_PLACEHOLDER = 'e.g.https?://.*.example.com';
export const ARIA_LABEL = 'URL Rule';
export const ACTION_SELECT_ARIA_LABEL = 'URL Rule action';
export const ACTION_SELECT_PLACEHOLDER = 'Select URL Rule';
export const VALUE_INPUT_LABEL = 'URL Rule Regex';
export const REMOVE_URL_BUTTON_TITLE = 'Remove Url Rule';

export const URL_ACTIONS: OptionType[] = [
	{ label: 'Include URLs', value: SCOPE_ACTIONS.INCLUDE },
	{ label: 'Exclude URLs', value: SCOPE_ACTIONS.EXCLUDE }
];
